module.exports = "https://cdn2-fs.clearscore.com/flux/images/5c558a0861173deac2eafb94eef93a41.jpg";